module.exports = __webpack_public_path__ + "img/dumbbell-light.ef471ab1.png";